import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../items/style/animationstyle';
import './machine_css.css';
import MachineCategoryCard from './machineCategoryCard';
import ToggleLanguage from '../items/buttons/ToggleLanguage';
import { useTranslation } from 'react-i18next';
import 'react-simple-keyboard/build/css/index.css';
import { ReactComponent as BackIcon } from '../Icons/Back_icon.svg';
import { ReactComponent as CartIcon } from '../Icons/Cart_icon.svg';
import { ReactComponent as HomeIcon } from '../Icons/Home_icon.svg';
import { ReactComponent as SearchIcon } from '../Icons/magnifier.svg';
import { Link } from 'react-router-dom';
import Search from './items/Search';
import logger from '../services/LocalServer/logger';
import MscName from './company/MSC/MscName';
import { ExitToApp } from '@material-ui/icons';
import BottomCart from './ShoppingCart/BottomCart';
import { useHistory } from 'react-router-dom';

function ProductCategories(props) {
  const history = useHistory();
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const {
    langs,
    stat,
    setStat,
    decreStock,
    alterquantity,
    remove,
    add,
    setShowCart,
    showCart,
    cart,
  } = props;
  const { t } = useTranslation();
  const machineID = props.id;

  let machine = JSON.parse(localStorage.getItem('machine'));
  let logoutIcon = localStorage.getItem('LOGOUT') === 'TRUE';
  const showName = machine?.themeColor?.brand_image_button === 'true' ? true : false;

  const bColumn = () => {
    let c = machine;
    let result = '1';
    if (c.themeColor && c.themeColor.b_column) {
      result = c.themeColor.b_column;
    }
    return result;
  };

  const b_column = bColumn();

  const fColumn = () => {
    let c = machine;
    let result = '1';
    if (c.themeColor && c.themeColor.c_column) {
      result = c.themeColor.c_column;
    }
    return result;
  };

  const [cate, setCates] = useState([]);
  const [column, setColumn] = useState('1');
  const [input, setInput] = useState('');
  const [languages, setLanguage] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setColumn(fColumn());

    setCates(
      JSON.parse(localStorage.getItem('category'))
        ? JSON.parse(localStorage.getItem('category'))
        : []
    );
    setLanguage(
      JSON.parse(localStorage.getItem('machine'))
        ? JSON.parse(localStorage.getItem('machine')).languages
        : null
    );
  }, []);

  let result;

  result = [...cate];

  //sort by name
  result = result?.sort((a, b) => {
    const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
    const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  const allCat = {
    key: 1,
    id: 1,
    name: {
      en: 'All Products',
      fr: 'Tous les produits',
      es: 'Todos los productos',
    },
    image:
      'https://jvmsaas.com/media/blog/cache/840x620/magefan_blog/Fashion-Shoes-Jewelry-2X._V510055193_3.jpg',
    machineID: machineID,
  };

  const brands = {
    key: 2,
    id: 2,
    name: {
      en: 'Brands',
      fr: 'Marques',
      es: 'Marcas',
    },
    image:
      'https://toplistin.com/wp-content/uploads/2020/03/Most-Popular-Streamed-Game-of-2020-1.png',
    machineID: machineID,
  };
  //apply all product image to brand cate if ...
  if (machine?.themeColor?.allProduct) {
    if (isLocal) {
      allCat.image = `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor.allProduct}`;
      brands.image = `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor.allProduct}`;
    } else {
      allCat.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allProduct}/${machine.belongTo}`;
      brands.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allProduct}/${machine.belongTo}`;
    }
  }

  if (machine?.themeColor?.allBrand) {
    brands.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allBrand}/${machine.belongTo}`;
  }

  if (isLocal)
    if (input.length > 0) {
      result = cate.filter((category) =>
        category.name[langs]?.toLowerCase().includes(input.toLowerCase())
      );
    }

  useEffect(() => {
    if (stat.all_cate) stat.all_cate = stat.all_cate += 1;
    else stat.all_cate = 1;
    setStat(stat);
  }, []);

  const categories = result.map((cate) => {
    const Canme = cate.name[langs] && cate.name[langs] !== '' ? cate.name[langs] : cate.name?.en;
    return (
      <div
        key={cate._id}
        className="row justify-content-center mb-4"
        onClick={() => {
          localStorage.setItem('currentCate', JSON.stringify(cate));
        }}
      >
        <MachineCategoryCard
          brandOrCate="cate"
          column={column}
          id={cate._id}
          showName={showName}
          machineID={machineID}
          catename={Canme}
          cateEn={cate.name.en}
          image={
            isLocal
              ? `${process.env.REACT_APP_LOCAL_API}/pictures/category/${cate.categoryPicture}`
              : `${process.env.REACT_APP_SERVER_API}/pictures/${cate.categoryPicture}/${cate.referTo}`
          }
        />
      </div>
    );
  });

  if (b_column !== '0') {
    categories.unshift(
      <div key={2} className="row justify-content-center mb-4">
        <MachineCategoryCard
          column={column}
          id={2}
          showName={showName}
          machineID={brands.machineID}
          catename={brands.name[langs]}
          cateEn={brands.name.en}
          image={brands.image}
        />
      </div>
    );
  }

  categories.unshift(
    <div key={1} className="row justify-content-center mb-4">
      <MachineCategoryCard
        column={column}
        brandOrCate="all"
        id={1}
        showName={showName}
        machineID={allCat.machineID}
        catename={allCat.name[langs]}
        cateEn={allCat.name.en}
        image={allCat.image}
      />
    </div>
  );

  return (
    <div className="ui-secondary-div">
      <motion.div
        key="category-div"
        className="container"
        initial="initial"
        exit="out"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}
      >
        <MscName />
        <img className="category-logo" alt="Logo" />
        <div className="row align-items-center justify-content-center">
          <div>
            {languages != null && (
              <ToggleLanguage
                setlangs={props.setlangs}
                langs={props.langs}
                p="p"
                l={languages}
                machineID={machineID}
              />
            )}
          </div>
          <div style={{ marginLeft: '50px' }}>
            <Search show={show} setShow={setShow} input={input} setInput={setInput} />
          </div>
        </div>
        <div className="row justify-content-center mt-5 mb-5">
          <span className="cat-title">
            {result.length == 0 ? (
              <h2>{t(`No matching categories is found`)}!</h2>
            ) : (
              t('Categories').toUpperCase()
            )}
          </span>
        </div>
        <div
          className="items-container"
          style={{ display: 'grid', gridTemplateColumns: `repeat(${column}, 1fr)` }}
        >
          {categories}
        </div>
      </motion.div>
      <div className="bottom-buttons-div">
        <span>
          <HomeIcon className="svg-style mr-3" />
        </span>
        <CartIcon
          className="svg-style myCartIcon"
          onClick={() => {
            if (localStorage.getItem('cartStyle') === 'true') {
              setShowCart(true);
            } else {
              history.push(`/machineUI/${props.machineID}/checkout`);
            }
          }}
        />
        <span className="item-counter-p">
          <span className="myCartCounter">{props.itemCounter}</span>
        </span>

        <BackIcon id="mybackIcon" className="svg-style ml-3 backIcon" />
        <span
          onClick={() => {
            setShow(true);
            setInput('');
          }}
        >
          <SearchIcon className="svg-style mr-3" />
        </span>
        {logoutIcon && (
          <Link to={`/machineUI/slider/${machineID}`}>
            <ExitToApp className="svg-style myCartIcon" />
          </Link>
        )}
      </div>
      <BottomCart
        isLocal={isLocal}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
      />
    </div>
  );
}
export default ProductCategories;
